import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

type LegendEntry = {
  label: string;
  color: string;
  value: number;
};

const List = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  listStyle: 'none',
  padding: 0,
  margin: 0,
}));

const ListItem = styled('li')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const Label = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  alignItems: 'center',
}));

const EntryColor = styled('div')<{ color: string }>(({ color, theme }) => ({
  display: 'inline-block',
  width: theme.spacing(4),
  height: theme.spacing(16),
  backgroundColor: color,
  borderRadius: theme.spacing(4),
  marginTop: -1,
}));

const DoughnutLegendItem = ({ label, color, value }: LegendEntry) => {
  return (
    <ListItem>
      <Label>
        <EntryColor color={color} />
        <Typography variant="text2" color={'text.secondary'}>
          {label}
        </Typography>
      </Label>
      <Typography variant="text1">{toLocaleBrowserSettings(value)}</Typography>
    </ListItem>
  );
};

export type DoughnutLegendProps = {
  legend: LegendEntry[];
};
export const DoughnutLegend = ({ legend }: DoughnutLegendProps) => {
  return (
    <List>
      {legend.map((item) => (
        <DoughnutLegendItem key={item.label} {...item} />
      ))}
    </List>
  );
};
